import { useFetchBuilderSession } from './useFetchBuilderSession'

export const useMutateBuilderSession = (() => {
  const authenticate = () => {
    const { authenticate } = useFetchBuilderSession()

    return useAsyncState(authenticate, undefined, { immediate: false })
  }

  const finalize = () => {
    const { finalize } = useFetchBuilderSession()

    return useAsyncState(finalize, undefined, { immediate: false })
  }

  const refreshParticipantToken = () => {
    const { refreshParticipantToken } = useFetchBuilderSession()

    return useAsyncState(refreshParticipantToken, undefined, { immediate: false })
  }

  return {
    authenticate,
    finalize,
    refreshParticipantToken,
  }
})()
